var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlaylist = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02036 0.547333C9.63188 1.02392 9.95715 1.63157 9.99618 2.37029C10.0352 3.109 9.775 3.73452 9.21553 4.24686L5.44888 7.82128C5.31877 7.94043 5.16914 8 5 8C4.83086 8 4.68123 7.94043 4.55112 7.82128L0.784472 4.24686C0.225003 3.73452 -0.0352143 3.109 0.00381841 2.37029C0.0428511 1.63157 0.368123 1.02392 0.979635 0.547333C1.51308 0.130317 2.12459 -0.0484036 2.81417 0.0111701C3.51676 0.058829 4.11526 0.314996 4.60967 0.779671L5 1.13711L5.39033 0.779671C5.88474 0.314996 6.47674 0.058829 7.16631 0.0111701C7.8689 -0.0484036 8.48692 0.130317 9.02036 0.547333Z",
    fill: "#8C8C8C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlaylist, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/playlist.7f64b6ab.svg";
export { ForwardRef as ReactComponent };